import {
    GET_AFFILIATES,
    GET_AFFILIATES_SUCCESS,
    GET_AFFILIATES_FAILED,

    SUBMIT_AFFILIATE_FORM,
    SUBMIT_AFFILIATE_FORM_SUCCESS,
    SUBMIT_AFFILIATE_FORM_FAILED,

    DELETE_AFFILIATE,
    DELETE_AFFILIATE_SUCCESS,
    DELETE_AFFILIATE_FAILED,

    GET_CURRENT_AFFILIATE,
    GET_CURRENT_AFFILIATE_SUCCESS,
    GET_CURRENT_AFFILIATE_FAILED
} from '../../constants/actionTypes';

const INIT_STATE = {
    loading: false,
    affiliates: [],
    submittingForm: false,
    error: null,
    deleting: false,
    currentAffiliate: null
};

const CountryReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_AFFILIATES:
            return { ...state, loading: true };
        case GET_AFFILIATES_SUCCESS:
            
            return { ...state, affiliates: action.payload.data, total: action.payload.total, currentAffiliate: null, loading: false, error: null };
        case GET_AFFILIATES_FAILED:
            return { ...state, error: action.payload, loading: false };

        case SUBMIT_AFFILIATE_FORM:
            return { ...state, error: null, submittingForm: true };
        case SUBMIT_AFFILIATE_FORM_SUCCESS:
            const alreadyExists = state.affiliates.find((item) => item.id === action.payload.id);
            let affiliates;
            let total = state.total;
            if (!alreadyExists) {
                affiliates = [action.payload, ...state.affiliates];
                total += 1;
            } else {
                affiliates = state.affiliates.map((item) => {
                if (item.id === action.payload.id) {
                  return action.payload;
                }
                return item;
              });
            }
            return { ...state, total,  affiliates, submittingForm: false };
        case SUBMIT_AFFILIATE_FORM_FAILED:
            return { ...state, error: action.payload, submittingForm: false };

        case DELETE_AFFILIATE:
            return { ...state, error: null, deleting: true };
        case DELETE_AFFILIATE_SUCCESS:
            return { ...state, total: state.total - 1, affiliates: state.affiliates.filter(item => item.id !== action.payload) , deleting: false };
        case DELETE_AFFILIATE_FAILED:
            return { ...state, error: action.payload, deleting: false };
        
        case GET_CURRENT_AFFILIATE:
            return { ...state, loading: true };
        case GET_CURRENT_AFFILIATE_SUCCESS:
            return { ...state, currentAffiliate: {...action.payload, permissions: action.payload.permissions}, loading: false, error: null };
        case GET_CURRENT_AFFILIATE_FAILED:
            return { ...state, error: action.payload, loading: false };
    
        
        default: return { ...state };
    }
}

export default CountryReducer;